// @mui
import PropTypes from "prop-types";
import { Card, Typography } from "@mui/material";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
// components
import Iconify from "../../../components/Iconify";
import "./style.css";

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

const getColorConfig = (color) => {
  switch (color) {
    case "info":
      return {
        bg: "#e0f7fa",      // Light Cyan
        text: "#006064",    // Dark Cyan
        iconBg: "rgba(0, 151, 167, 0.15)",
        iconColor: "#0097a7",
      };
    case "warning":
      return {
        bg: "#fff3e0",      // Light Orange
        text: "#e65100",    // Dark Orange
        iconBg: "rgba(230, 81, 0, 0.15)",
        iconColor: "#e65100",
      };
    case "error":
      return {
        bg: "#ffebee",      // Light Red
        text: "#b71c1c",    // Dark Red
        iconBg: "rgba(198, 40, 40, 0.15)",
        iconColor: "#c62828",
      };
    case "secondary":
      return {
        bg: "#fce4ec",      // Light Pink
        text: "#880e4f",    // Dark Pink
        iconBg: "rgba(173, 20, 87, 0.15)",
        iconColor: "#ad1457",
      };
    case "primary":
    default:
      return {
        bg: "#f2ebff",      // Light Purple
        text: "#4a148c",    // Dark Purple
        iconBg: "rgba(106, 27, 154, 0.15)",
        iconColor: "#6a1b9a",
      };
  }
};

export default function AppWidgetSummary({
  title,
  total,
  icon,
  color = "primary",
  sx,
  ...other
}) {
  const config = getColorConfig(color);

  return (
    <Card
      className="Display_details"
      sx={{
        padding: 3,
        boxShadow: "0 4px 20px 0 rgba(145, 158, 171, 0.08)",
        textAlign: "center",
        color: config.text,
        bgcolor: config.bg,
        borderRadius: 2.5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        border: "1px solid rgba(145, 158, 171, 0.08)",
        ...sx,
      }}
      {...other}
    >
      <div
        style={{
          margin: "0 auto 16px auto",
          display: "flex",
          borderRadius: "50%",
          alignItems: "center",
          width: "56px",
          height: "56px",
          justifyContent: "center",
          backgroundColor: config.iconBg,
        }}
      >
        <Iconify icon={icon} width={24} height={24} color={config.iconColor} />
      </div>

      <Typography variant="h3" sx={{ fontWeight: 800, mb: 0.5, color: config.text }}>
        {fShortenNumber(total ? total : 0)}
      </Typography>

      <Typography variant="subtitle2" sx={{ opacity: 0.72, fontWeight: 700, color: config.text }}>
        {title}
      </Typography>
    </Card>
  );
}
